import Env from 'Env'

export default function (imgName: string) {
  return `${Env.CdnUrl}/images/${imgName}`
}
